<template>
  <div class="IberoForm">
    <div class="form-container">
      <div class="form-row">
        <div
          :id="'div_' + item.id"
          :class="[item.class]"
          class="nav"
          v-for="item of FieldsForm"
          :key="item.id"
          :v-if="item.hidden != true"
          :style="{ display: !item.hidden ? '' : 'none' }"
        >
          <div class="titleRef col-md-12">{{ item.name }}</div>
          <div class="inputRef col-md-12">
            <ValidationProvider
              :class="{ classes: true }"
              :name="item.name"
              :rules="item.validate"
              v-slot="{ classes, errors }"
            >
              <div v-if="item.type === 'password'">
                <input
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  type="password"
                  autocomplete="off"
                  maxlength="100"
                  :class="classes"
                />
              </div>
              <div v-else-if="item.type === 'input'">
                <input
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @input="executeProcess($event, item)"
                  @keyup="executeProcess($event, item)"
                  @blur="executeProcess($event, item)"
                />
              </div>
              <div v-else-if="item.type === 'inputkey'">
                <input
                  autocomplete="off"
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @click="executeProcess($event, item)"
                  @keyup="executeProcess($event, item)"
                />
              </div>
              <div v-else-if="item.type === 'file'" class="custom-file" v-show="!item.hidden">
                <input
                    :id="item.id"
                    :name="item.id"
                    :placeholder="item.placeholder"
                    :idUbication="item.model"
                    class="custom-file-input col-md-12"
                    :class="classes"
                    type="file"
                    @change="executeProcess($event, item)"/>
                <label class="custom-file-label" data-browse="Archivo" :for="item.id">
                    {{ item.fileName || item.placeholder || 'Seleccione archivo' }}
                </label>
              </div>
              <div v-else-if="item.type === 'file_detail'">
                <div class="table-responsive-sm">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th width="10%" scope="row">{{ item.idFile }}</th>
                        <td width="50%">{{ item.dataFile.Nam_File }}</td>
                        <td width="20%">
                          {{ formatBytes(item.dataFile.Size, 0) }}
                        </td>
                        <td width="20%" class="text-right">
                          <a :href="item.DetURI" target="_blank">
                            <img
                              width="20"
                              height="20"
                              src="@/assets/images/detail.png"
                              class="img-fluid"
                              title="Ver Documento"
                              alt="Ver Documento"
                            />
                          </a>
                          
                          <img
                            v-if="item.delete"
                            width="20"
                            height="20"
                            src="@/assets/images/DocSend.png"
                            class="img-fluid"
                            title="Enviar Documento"
                            alt="Enviar Documento"
                            @click="fileClosedFunction(item, 'Send')"
                          />
                          <img
                            v-if="!item.delete"
                            width="20"
                            height="20"
                            src="@/assets/images/DocYes.png"
                            class="img-fluid"
                            title="Documento Enviado"
                            alt="Documento Enviado"
                          />
                          <img
                            width="20"
                            height="20"
                            src="@/assets/images/inactive.png"
                            class="img-fluid"
                            title="Eliminar Documento"
                            alt="Eliminar Documento"
                            @click="fileClosedFunction(item, 'Delete')"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else-if="item.type === 'Select'">
                <select
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  class="form-control col-md-12"
                  :disabled="item.disabled === true"
                  @change="executeProcess($event, item)"
                  :class="classes"
                >
                  <option
                    value
                    selected="selected"
                    v-if="item.placeholder !== ''"
                  >
                    {{ item.placeholder }}
                  </option>
                  <option
                    v-for="itemList of item.values"
                    v-bind:value="itemList.id"
                    :key="itemList.id"
                    :code="itemList.codVal"
                  >
                    {{ itemList.value }}
                  </option>
                </select>
              </div>

              <div v-else-if="item.type === 'Select2'">
                <select
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  class="form-control col-md-12"
                  :disabled="item.disabled === true"
                  @change="executeProcess($event, item)"
                  :class="classes"
                >
                  <option
                    value
                    selected="selected"
                    v-if="item.placeholder !== ''"
                  >
                    {{ item.placeholder }}
                  </option>
                  <option
                    v-for="itemList of item.values"
                    v-bind:value="itemList.nomenclature"
                    :key="itemList.nomenclature"
                    :code="itemList.codVal"
                  >
                    {{ itemList.value }}
                  </option>
                </select>
                <span class="form-control col-md-12">{{ ModelForm[item.model] }}</span>
              </div>
            
              <div v-else-if="item.type === 'datepicker'">
                <datepicker
                  v-model="ModelForm[item.model]"
                  :bootstrap-styling="true"
                  :monday-first="true"
                  :highlighted="item.dateTimePickerOptions.highlighted"
                  :disabled-dates="item.dateTimePickerOptions.disabledDates"
                  :format="item.dateTimePickerOptions.format"
                  :placeholder="item.placeholder"
                  :language="es"
                  :name="item.name"
                  :id="item.id"
                  :input-class="classes"
                  @closed="datepickerClosedFunction(item)"
                ></datepicker>
              </div>
              <div v-else-if="item.type === 'accepted'" class="col-md-12">
                <input
                  v-model="ModelForm[item.model]"
                  type="checkbox"
                  :id="'cbox_' + item.id"
                  @change="executeProcess($event, item)"
                  :class="classes"
                  :disabled="item.disabled"
                />&nbsp;
                <label
                  :for="'cbox_' + item.id"
                  v-html="item.placeholder"
                ></label>
              </div>
              <div v-else-if="item.type === 'ClearZone'"></div>
              <div v-else-if="item.type === 'informative'">
                <strong>{{ ModelForm[item.model] }}</strong>
              </div>
              <div v-else-if="item.type === 'textarea'">
                <textarea
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @keyup="executeProcess($event, item)"
                  @blur="executeProcess($event, item)"
                >
                </textarea>
              </div>
              <div v-else-if="item.type === 'html'">
                <div v-html="item.values"></div>
              </div>
              <div v-else-if="item.type === 'button'">
                <button
                  :id="'btn_' + item.id"
                  type="submit"
                  v-on:click="executeProcess($event, item)"
                  class="btn btn-lg btn-block botonRef"
                >
                  {{ item.placeholder }}
                </button>
              </div>
              <div v-else>
                Requiere un formato correcto para el campo del formulario
              </div>
              <div :id="'error_' + item.id" class="is-invalid-form">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import IberoHelpers from "@/store/helpers.js";

export default {
  name: "IberoForm",
  methods: {
    executeProcess(event, item) {
      let evt = event;
      if (!evt || !evt.target) {
        evt = { target: { id: '', value: '' } };
        if (item && item.id) evt.target.id = item.id;
        if (item && item.model && this.ModelForm && this.ModelForm[item.model] !== undefined) evt.target.value = this.ModelForm[item.model];
      }
      if (typeof console !== 'undefined' && console.log) console.log('[IberoForm] executeProcess ->', evt && evt.target ? { id: evt.target.id, value: evt.target.value } : evt);
      try {
        // Prefer the explicit method prop first, especially for file inputs.
        if (typeof this.method === 'function') {
          console.log('[IberoForm] calling method prop ->', evt && evt.target ? { id: evt.target.id, value: evt.target.value } : evt);
          this.method(evt, item);
          return;
        }

        // Try to find the nearest ancestor that implements `executeProcess` and call it directly.
        let caller = null;
        let anc = this.$parent;
        while (anc) {
          if (typeof anc.executeProcess === 'function') {
            caller = anc.executeProcess.bind(anc);
            break;
          }
          anc = anc.$parent;
        }

        if (caller) {
          console.log('[IberoForm] calling ancestor executeProcess ->', evt && evt.target ? { id: evt.target.id, value: evt.target.value } : evt);
          caller(evt, item);
          return;
        }

        console.warn('[IberoForm] no method prop or ancestor executeProcess found');
      } catch (e) {
        console.error('[IberoForm] executeProcess error', e);
      }
    },
    datepickerClosedFunction(dataref) {
      var event = new Object();
      var target = new Object();
      target.id = dataref.id;
      target.value = dataref.values;
      event.target = target;
      if (typeof this.method === 'function') {
        try {
          if (this.$parent) this.method.call(this.$parent, event);
          else this.method(event);
        } catch (e) {
          try { this.method(event); } catch (err) { console.error(err); }
        }
      }
    },
    fileClosedFunction(dataref, refEvent) {
      if (typeof this.method === 'function') {
        try {
          if (this.$parent) this.method.call(this.$parent, dataref, refEvent);
          else this.method(dataref, refEvent);
        } catch (e) {
          try { this.method(dataref, refEvent); } catch (err) { console.error(err); }
        }
      }
    },
    formatBytes(bytes, decimals) {
      return IberoHelpers.formatBytes(bytes, decimals);
    },
  },
  data() {
    return {
      es: es,
    };
  },
  components: {
    Datepicker,
  },
  props: {
    method: Function,
    ModelForm: {
      type: Object,
      default: () => ({}),
    },
    FieldsForm: Array,
  },
};
</script>

<style>
.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}

.titleRef {
  font-weight: bold;
  padding-bottom: 0px;
  margin-top: 30px;
  font-size: 20px;
}

.btn {
  color: #000;
  background-color: #fff;
  border: 3px solid #000;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.datepicker {
  padding-bottom: 30px;
}

.is-invalid-form {
  color: red;
  height: 10px;
  font-size: 12px;
}

.custom-file-size {
  color: red;
  height: 10px;
  font-size: 12px;
}

.form-control {
  margin-top: 10px !important;
  margin-bottom: 0px !important;
}

.table {
  width: 100%;
}
.img-fluid {
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
}
</style>